import React from 'react';

import PropTypes from 'prop-types';

import {
    MarkdownContent,
    Typography,
    Section,
} from 'wanderu-components';

import Shuttle from '../Shuttle';

import styles from './ShuttlesSection.scss';

function ShuttlesSection({
    title,
    description,
    shuttles,
    url,
}) {
    return (
        <Section id="shuttles-section">
            <Typography
                className={styles.heading}
                variant="h3"
            >
                {title}
            </Typography>
            <Typography
                className={styles.description}
                component={MarkdownContent}
                paragraph
            >
                {description}
            </Typography>
            <ul className={styles.shuttlesList}>
                {shuttles.map((shuttleData, index) => (
                    <li className={styles.shuttleItem} key={shuttleData.name}>
                        <Shuttle
                            description={shuttleData.description}
                            logo={shuttleData.logo}
                            name={shuttleData.name}
                            phoneNumber={shuttleData.phoneNumber}
                            url={url}
                            website={shuttleData.website}
                        />
                    </li>
                ))}
            </ul>
        </Section>
    );
}

ShuttlesSection.propTypes = {
    description: PropTypes.string.isRequired,
    shuttles: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default ShuttlesSection;
